import * as React from 'react'
import Dropzone, { Accept } from 'react-dropzone'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  placeholder: string
  description: string
  selectedFile: File | undefined
  onDrop: (file: File[]) => void
  acceptedFormats: Accept
}

const FileUploader = ({
  placeholder,
  description,
  selectedFile,
  onDrop,
  acceptedFormats,
}: Props) => {
  return (
    <Dropzone onDrop={onDrop} accept={acceptedFormats}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={'FileUploader_dropzone'}>
          <input {...getInputProps()} />
          <Box
            width="full"
            textAlign="center"
            padding="s12"
            borderRadius={{ all: 'abs006' }}
            border={{
              all: {
                width: 's2',
                style: 'dashed',
                color: 'grey400',
              },
            }}
          >
            <Box flexDirection="column" alignItems="center" paddingBottom="s32" cursor="pointer">
              {selectedFile?.name ? (
                <Box alignItems="center" gap="s12" paddingTop="s32">
                  <Icon.Large icon="file-upload" />
                  <Text.Normal>{selectedFile.name}</Text.Normal>
                </Box>
              ) : (
                <>
                  <Box paddingTop="s32" paddingBottom="s12">
                    <Icon.Large icon="file-upload" color="grey700" />
                  </Box>
                  <Text.Normal weight="medium" size="300" color="grey800">
                    {placeholder}
                  </Text.Normal>
                  <Text weight="normal" caps size="200" color="grey800">
                    {description}
                  </Text>
                </>
              )}
            </Box>
          </Box>
        </div>
      )}
    </Dropzone>
  )
}

export default FileUploader
